import React, { ChangeEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useFormikContext } from 'formik';

import TextField from '@common/components/Form/TextField';

interface AnimationStartEvent extends AnimationEvent {
	target: HTMLInputElement & {
		name: string;
		matches(selectors: string): boolean;
	};
}

export const useAnimationStartHandler = () => {
	const formik = useFormikContext();

	return (e: AnimationStartEvent) => {
		const { name, value } = e.target;
		const autofilled = e.target.matches('*:-webkit-autofill');

		if (e.animationName === 'mui-auto-fill' || e.animationName === 'mui-auto-fill-cancel') {
			formik.setFieldValue(name, autofilled ? value : '', true);

			// Імітуємо подію change для оновлення стану Formik
			const changeEvent = {
				target: {
					name,
					value: autofilled ? value : '',
				},
			} as ChangeEvent<HTMLInputElement>;
			formik.handleChange(changeEvent);
		}
	};
};

function LoginForm() {
	const { t } = useTranslation();
	const [passwordHasValue, setPasswordHasValue] = useState(false);
	const [nameHasValue, setNameHasValue] = useState(false);
	const { values } = useFormikContext<any>();
	// function to remove overlay while browser autocomplete textfield
	const makeAnimationStartHandler = (stateSetter: (boolean: boolean) => void) => (e: any) => {
		const autofilled = !!e.target?.matches('*:-webkit-autofill');
		if (e.animationName === 'mui-auto-fill') {
			stateSetter(autofilled);
		}

		if (e.animationName === 'mui-auto-fill-cancel') {
			stateSetter(autofilled);
		}
	};

	return (
		<>
			<TextField
				label="E-mail*"
				type="text"
				name="email"
				inputProps={{
					onAnimationStart: makeAnimationStartHandler(setNameHasValue),
				}}
				InputLabelProps={{
					shrink: Boolean(nameHasValue || values?.email),
				}}
			/>
			<TextField
				label="Password*"
				type="password"
				name="password"
				inputProps={{
					onAnimationStart: makeAnimationStartHandler(setPasswordHasValue),
				}}
				InputLabelProps={{
					shrink: Boolean(passwordHasValue || values?.password),
				}}
			/>
			<FormControlLabel
				name="remember"
				control={<Checkbox defaultChecked />}
				label={t('shared.rememberMe')}
			/>
		</>
	);
}

export default LoginForm;
